var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    { staticClass: "container-layout" },
    [
      _vm.menu.length
        ? _c(
            "el-header",
            {
              staticClass: "container-layout-header",
              attrs: { height: "35px" }
            },
            [
              _vm.menu
                ? _c(
                    "div",
                    { staticClass: "menu-f" },
                    [
                      _c(
                        "el-menu",
                        {
                          attrs: {
                            router: _vm.router,
                            "default-active": _vm.defaultMenu.toString(),
                            mode: "horizontal"
                          },
                          on: { select: _vm.selectMainMenu }
                        },
                        [
                          _vm._l(_vm.menu, function(item, i) {
                            return [
                              _c(
                                "el-menu-item",
                                {
                                  key: item.type,
                                  attrs: {
                                    index: _vm.router ? item.path : i.toString()
                                  }
                                },
                                [_vm._v(_vm._s(item.type))]
                              )
                            ]
                          })
                        ],
                        2
                      ),
                      _c(
                        "span",
                        { staticClass: "menu-r" },
                        [_vm._t("upload")],
                        2
                      ),
                      _c(
                        "div",
                        { staticClass: "menu-center" },
                        [_vm._t("center")],
                        2
                      ),
                      _c(
                        "div",
                        { staticClass: "menu-right" },
                        [_vm._t("right")],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showSecondMenu
                ? _c("el-col", { attrs: { span: 24 } }, [
                    _c(
                      "div",
                      { staticClass: "menu-c" },
                      [
                        _c(
                          "el-menu",
                          {
                            attrs: {
                              "default-active": _vm.activeIndex,
                              mode: "horizontal",
                              router: _vm.childRouter
                            },
                            on: { select: _vm.selectMenu }
                          },
                          _vm._l(_vm.menu[_vm.current].children, function(
                            item,
                            index
                          ) {
                            return _c(
                              "el-menu-item",
                              {
                                key: item,
                                attrs: {
                                  index: _vm.childRouter
                                    ? item.path
                                    : index.toString()
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.childRouter ? item.name : item)
                                )
                              ]
                            )
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-container",
        {
          staticClass: "container-layout-content",
          class: { modeldatainfo: _vm.menu.length }
        },
        [
          _vm.showAside
            ? _c(
                "el-aside",
                { attrs: { width: "230px" } },
                [_vm._t("aside")],
                2
              )
            : _vm._e(),
          _c(
            "el-main",
            { staticClass: "container-el-main" },
            [_vm._t("main")],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }